import produce from "immer"
import { PUBLISHED, TYPE_A, DESC, PROVEN_NO } from "const"
import {
    QidModel,
    QidModelSafetyFunction,
    QidModelOption,
    QidModelFailureMode,
} from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initQidModel: QidModel = {
    id: null,
    productId: null,
    name: "",
    type: TYPE_A,
    lowDemandMode: true,
    highDemandMode: false,
    continuousMode: false,
    logicSolver: false,
    provenInUse: PROVEN_NO,
    status: PUBLISHED,
}

export const initQidModelSafetyFunction: QidModelSafetyFunction = {
    id: null,
    modelId: null,
    name: "",
    type: TYPE_A,
    lowDemandMode: true,
    highDemandMode: false,
    continuousMode: false,
    logicSolver: false,
    provenInUse: PROVEN_NO,
}

export const initQidModelOption: QidModelOption = {
    id: null,
    safetyFunctionId: null,
    name: "",
}

export const initQidModelFailureMode: QidModelFailureMode = {
    id: null,
    safetyFunctionId: null,
    name: "",
}

const initQidModelState: types.QidModelState = {
    modelList: {},
    modelIds: [],

    expandedModelIds: [],
    expandedSafetyFunctionIds: [],

    sortColumn: "createdAt",
    sortOrder: DESC,
    filters: {
        search: null,
    },

    changeStatusModel: null,

    editModel: null,
    editSafetyFunction: null,
    editOption: null,
    editFailureMode: null,

    deleteModel: null,
    deleteSafetyFunction: null,
    deleteOption: null,
    deleteFailureMode: null,

    reloadList: true,
    reloadEditModel: true,
    reloadEditSafetyFunction: true,
}

const qidModelReducer = produce((
    draft: types.QidModelState = initQidModelState,
    action: ActionTypes = null,
): types.QidModelState => {
    switch (action.type) {
        case types.QID_MODEL_LIST:
            draft.modelList = action.modelList
            return draft

        case types.QID_MODEL_IDS:
            draft.modelIds = action.modelIds
            return draft

        case types.QID_MODEL_EXPANDED_MODEL_IDS:
            draft.expandedModelIds = action.modelIds
            return draft

        case types.QID_MODEL_EXPANDED_SAFETY_FUNCTION_IDS:
            draft.expandedSafetyFunctionIds = action.safetyFunctionIds
            return draft

        case types.QID_MODEL_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.QID_MODEL_FILTERS:
            draft.filters = action.filters
            return draft

        case types.QID_MODEL_CHANGE_STATUS_MODEL:
            draft.changeStatusModel = action.model
            return draft

        case types.QID_MODEL_EDIT_MODEL:
            draft.editModel = action.model
            return draft

        case types.QID_MODEL_EDIT_SAFETY_FUNCTION:
            draft.editSafetyFunction = action.safetyFunction
            return draft

        case types.QID_MODEL_EDIT_OPTION:
            draft.editOption = action.option
            return draft

        case types.QID_MODEL_EDIT_FAILURE_MODE:
            draft.editFailureMode = action.failureMode
            return draft

        case types.QID_MODEL_DELETE_MODEL:
            draft.deleteModel = action.model
            return draft

        case types.QID_MODEL_DELETE_SAFETY_FUNCTION:
            draft.deleteSafetyFunction = action.safetyFunction
            return draft

        case types.QID_MODEL_DELETE_OPTION:
            draft.deleteOption = action.option
            return draft

        case types.QID_MODEL_DELETE_FAILURE_MODE:
            draft.deleteFailureMode = action.failureMode
            return draft

        case types.QID_MODEL_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.QID_MODEL_RELOAD_EDIT_MODEL:
            draft.reloadEditModel = action.value
            return draft

        case types.QID_MODEL_RELOAD_EDIT_SAFETY_FUNCTION:
            draft.reloadEditSafetyFunction = action.value
            return draft

        default:
            return draft
    }
})
export default qidModelReducer
